/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';

import ReadingComposer from '../Shared/Composer/ReadingComposer';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import Link from 'next/link';
import { getUsersList, userSelector } from '../../store/feature/user/userSlice';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../Shared/Pagination/Pagination';
import UsersSkeletonUi from '../Shared/skeletonUI/UsersSkeletonUi';
import DynamicUserCardLayout from './DynamicUserCardLayout';

const UsersList = ({ styles, data }) => {
  const [pageCount, setPageCount] = useState(0);
  const { users_list, total_records, page, isListFetching } =
    useSelector(userSelector);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getUsersList({
        params: { page: 1, per_page: data?.per_page ? data?.per_page : 30 },
      })
    );
  }, []);

  // Count and set total page
  useEffect(() => {
    const totalpage = Math.ceil(total_records / 30);
    if (Number(total_records) > 30) {
      setPageCount(totalpage);
    }
  }, [total_records]);

  const moreUsers = (current_page) => {
    dispatch(
      getUsersList({
        params: {
          page: current_page,
          per_page: data?.per_page ? data?.per_page : 30,
        },
      })
    );
  };

  return (
    <>
      <div
        style={{
          display: styles?.main_styles?.display,
          ...get_dynamic_styles(styles?.main_styles),
        }}
      >
        {users_list !== null &&
          !isListFetching &&
          users_list?.map((user) => <DynamicUserCardLayout user={user} />)}

        {isListFetching && (
          <UsersSkeletonUi per_page={data?.per_page ? data?.per_page : 30} />
        )}
      </div>

      {users_list !== null && data?.pagination_enabled && (
        <div className="w-full mt-12   flex justify-center pb-12 ">
          <Pagination
            current_page={page}
            pageCount={pageCount}
            moreData={moreUsers}
          />
        </div>
      )}
    </>
  );
};

export default UsersList;
